import { useEffect, useState } from 'react';
import { getAllLocations } from '../../services/location';
import useWebData from '../../hooks/useWebData';
import { tenantId } from '../../config/api';
import { Helmet } from 'react-helmet-async';

const Locations = () => {
  const { webData }: any = useWebData();
  const [locations, setLocations] = useState<any[]>([]);
  const [selectedItem, setSelectedItem] = useState<number>(0);

  useEffect(() => {
    getAllLocations(tenantId)
      .then((data) => {
        const result = data.map((item: any, index: number) => {
          return {
            ...item,
            id: index
          }
        })
        setLocations(result);
        setSelectedItem(result[0]?.id);
      })
      .catch((error) => {
        console.error(error);
        setLocations([]);
      })

    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const renderContent = () => {
    const location = locations?.find((item: any) => item.id === selectedItem);
    if (!location) {
      return <div className='h-[450px] w-full flex items-center justify-center'>
        <span className='text-lg font-medium inline-block'>No Locations</span>
      </div>;
    }
    const fullAddress = `${location.street}, ${location.city}, ${location.state}, ${location.zipCode}`;
    const encodedAddress = encodeURIComponent(fullAddress);
    return (
      <div>
        <iframe
          title="Google Map"
          src={`https://maps.google.com/maps?width=100%25&height=300&hl=en&q=${encodedAddress}&t=&z=10&ie=UTF8&iwloc=B&output=embed`}
          width="100%"
          height="450"
          style={{ border: 0, padding: '10px' }}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    );
  };

  return (
    <>
      <Helmet>
        <title>Vehicle & Van Rental Branches | Our Locations</title>
        <meta
          name="description"
          content="Find our vehicle and van rental locations. View branch addresses, select a location, and access rental details for easy trip planning."
        />
      </Helmet>
      <div className="flex flex-col md:flex-row mt-[140px]">
        {/* Sidebar */}
        <aside className="w-full md:w-64 p-4 border-r border-gray-200 bg-white">
          <h2 className="text-lg font-bold mb-6">Our Vehicle Rental Locations</h2>
          <ul className="space-y-2 max-h-[380px] overflow-y-auto">
            {locations?.map((item) => (
              <li
                key={item.id}
                className={`cursor-pointer  hover:bg-gray-100 transition border-b-2 border-b-gray-200 ${selectedItem === item.id ? 'rounded' : ''}`}
                onClick={() => setSelectedItem(item.id)}
              >
                <div className={`rounded p-2 ${selectedItem === item.id ? 'bg-gray-200' : ''}`}>
                  <span
                    className="text-sm font-semibold block"
                    style={{
                      color: webData?.websiteHeaderColor,
                    }}
                  >
                    {item?.locationName}
                  </span>
                  <span className="text-xs font-medium">
                    {item?.street}, {item?.city}, {item?.state} {item?.zipCode}, {item?.country}
                  </span>
                </div>
              </li>
            ))}
          </ul>
        </aside>

        {/* Content */}
        <main className="flex-1 p-4 bg-gray-50">
          <div className="text-base">{renderContent()}</div>
        </main>
      </div>
    </>


  )
}

export default Locations